import React from 'react';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Route, Redirect } from 'react-router-dom';

import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Utilidades de Ionic (ion-padding-*, ion-margin-*, ion-text-center, ...) */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Global Design System Variables */
import './theme/variables.css';
import './theme/global.css';

import Login from './pages/login/Login';
import Dashboard from './pages/dashboard/Dashboard';
import FormUser from './pages/form/FormUser';
import VerReferidos from './pages/referidos/VerReferidos';
import EditarReferido from './pages/referidos/EditarReferido';
import CambiarContrasena from './pages/dashboard/CambiarContrasena';
import RecuperarContrasena from './pages/login/RecuperarContrasena';
import EditarPerfil from './pages/dashboard/EditarPerfil';
import Signup from './pages/signup/Signup';
import Usuarios from './pages/usuarios/Usuarios';
import ProtectedRoute from './pages/login/ProtectedRoutes';
import { isSessionValid } from './pages/login/validacion';
import { UserProvider } from './context/UserContext';

setupIonicReact();

// Rol guardado al iniciar sesión (ver UserContext)
const esAdmin = () => {
  try {
    return JSON.parse(localStorage.getItem('user') ?? 'null')?.rol === 'admin';
  } catch {
    return false;
  }
};

const App: React.FC = () => {

  return (
    <UserProvider>
      <IonApp>
      <IonReactRouter>
        <IonRouterOutlet>
          <Route
            path="/"
            exact={true}
            component={Login}
          />

          <Route
            path="/panel"
            exact={true}
            render={() => isSessionValid() ? <Dashboard /> : <Redirect to="/" />}
          />

          <Route
            path="/registrar-referido"
            exact={true}
            render={() => isSessionValid() ? <FormUser /> : <Redirect to="/" />}
          />

          <Route
            path="/ver-referidos"
            exact={true}
            render={() => isSessionValid() ? <VerReferidos /> : <Redirect to="/" />}
          />

          <Route
            path="/editar-referido/:id"
            exact={true}
            render={() => isSessionValid() ? <EditarReferido /> : <Redirect to="/" />}
          />

          <Route
            path="/cambiar-contrasena"
            exact={true}
            component={CambiarContrasena}
          />

          <Route
            path="/perfil"
            exact={true}
            render={() => isSessionValid() ? <EditarPerfil /> : <Redirect to="/" />}
          />

          {/* Solo administradores; el backend también lo verifica en cada petición */}
          <Route
            path="/usuarios"
            exact={true}
            render={() => !isSessionValid() ? <Redirect to="/" /> : esAdmin() ? <Usuarios /> : <Redirect to="/panel" />}
          />

          <Route
            path="/recuperar-contrasena"
            exact={true}
            component={RecuperarContrasena}
          />

          <Route
            path="/registrar"
            exact
            component={Signup}
          />

          <Route>
            <Redirect to="/" />
          </Route>
        </IonRouterOutlet>
      </IonReactRouter>
      </IonApp>
    </UserProvider>
  );
};

export default App;